module.exports = __webpack_public_path__ + "img/perminow.e19af63f.png";